// src/pages/BalancesLayout.jsx

import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "axios";
import config from '../config/config';

import FlashBar from "../components/FlashBar";
import NavigationBar from "../components/NavigationBar";
import HeroSection from "../components/HeroSection";
import Banner from "../components/Banner";
import CategorySection from "../components/Categories";
import ProductSection from "../components/ProductSection";
import Testimonials from "../components/Testimonials";
import Cta from "../components/Cta";
import ModalSection from "../components/ModalSection";

import CategoriesNav from "../components/CategoriesNav";
import Faqs from "../components/Faqs";
import Christmas from "../components/ChristmasWidgets";
import CartSection from "../components/CartSection";
import FooterSection from "../components/FooterSection";
import ProductView from "../components/ProductView";
import SearchWidget from "../components/SearchWidget";
import { useQuery } from '@tanstack/react-query'; 
import { fetchLayoutSettings } from '../libs/apis/LayoutSettingsApi';

import { 
  LayoutDashboard, Zap, Grid, ShoppingBag, Footprints, 
  Image as ImageIcon, Star, Plus, X, RefreshCw 
} from 'lucide-react';


// Admin editors (lazy loaded)
const FlashBarAdmin    = React.lazy(() => import("../pages/FlashBar"));
const NavigationAdmin  = React.lazy(() => import("../pages/NavigationBar"));
const HeroAdmin        = React.lazy(() => import("../pages/HeroAdmin"));
const BannerAdmin      = React.lazy(() => import("../pages/BannerAdmin"));
const CategoryAdmin    = React.lazy(() => import("../pages/CategoryAdmin"));
const ProductAdmin     = React.lazy(() => import("../pages/ProductAdmin"));
const CartAdmin        = React.lazy(() => import("../pages/CartAdmin"));
const FooterAdmin      = React.lazy(() => import("../pages/FooterAdmin"));
const SearchAdmin      = React.lazy(() => import("../pages/SearchAdmin"));
const TestimonialsAdmin      = React.lazy(() => import("../pages/TestimonialsAdmin"));
const ModalAdmin      = React.lazy(() => import("../pages/ModalAdmin"));
const CtaAdmin      = React.lazy(() => import("../pages/CtaAdmin"));
const CategoriesNavAdmin      = React.lazy(() => import("../pages/CategoriesNavAdmin"));

const FaqAdmin      = React.lazy(() => import("../pages/FaqAdmin"));
const ChristmasAdmin      = React.lazy(() => import("../pages/ChristmasAdmin"));
const ProductViewAdmin = React.lazy(() => import("../pages/ProductView"));


function SkeletonSection({ height = "300px", className = "" }) {
  return (
    <div className={`w-full animate-pulse bg-gray-100 ${className}`} style={{ minHeight: height }}>
     {/* <div className="h-full flex items-center justify-center text-gray-400 text-sm">
        Loading section...
      </div>*/}
    </div>
  );
}

// ──────────────────────────────────────────────────────────────────────────────

function BalancesLayout() {
  const [isAdminMode, setIsAdminMode] = useState(false);
   const [isAdmin, setIsAdmin] = useState(false);
  const [saving, setSaving] = useState(false);
  const token = localStorage.getItem("token");
const { data: layout = {}, isLoading, error, refetch } = useQuery({
  queryKey: ['layouthome'],
  queryFn: fetchLayoutSettings,
  staleTime: 1000 * 60 * 60,
  gcTime: 1000 * 60 * 60 * 24,
  retry: 2,
});

const CACHE_KEY_LAYOUT = 'layout_settings_cache_shopp';

  const [sectionOrder, setSectionOrder] = useState([]);
  const [globalConfigs, setGlobalConfigs] = useState({});
    const [searchConfig, setSearchConfig] = useState(null);
     const [CatConfig, setCatConfig] = useState({});
  const [cartConfig, setCartConfig] = useState(null);
  const [customConfigs, setCustomConfigs] = useState({});
  const [customSettings,setCustomSettings]=useState({});

  const [editingSlug, setEditingSlug] = useState(null);
  const [dataVersion, setDataVersion] = useState(0);

    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [adding, setAdding] = useState(false);
  const [addError, setAddError] = useState(null);
  const [addSuccess, setAddSuccess] = useState(null);

  const system_role = localStorage.getItem('system_role');
////console.log(userInfo);

   const availableSections = [
   // { id: 'navbar', name: 'Navigation Bar', icon: LayoutDashboard, color: 'bg-indigo-100 text-indigo-600' },
    { id: 'flashbar', name: 'Flash Bar', icon: Zap, color: 'bg-amber-100 text-amber-600' },
    { id: 'categories', name: 'Categories', icon: Grid, color: 'bg-green-100 text-green-600' },
    { id: 'products', name: 'Products', icon: ShoppingBag, color: 'bg-blue-100 text-blue-600' },
    { id: 'footer', name: 'Footer', icon: Footprints, color: 'bg-gray-100 text-gray-600' },
    { id: 'banner', name: 'Banner', icon: ImageIcon, color: 'bg-purple-100 text-purple-600' },
    { id: 'hero', name: 'Hero', icon: Star, color: 'bg-pink-100 text-pink-600' },
  ];

  const hasFetched = useRef(false);

  const CACHE_KEY = 'cms-layouts-490040-'+dataVersion;
  const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours
//const CACHE_TTL = 1000;
  
 const loadMissingCustom = () => {
  //console.log('Here yes',sectionOrder?.length);
  setSectionOrder(layout?.freshOrder);
       if (sectionOrder?.length === 0) return;

    const customSlugs = layout?.freshOrder.filter(slug => slug.includes('-'));

    if (customSlugs?.length === 0) return;
//console.log('slugs',customSlugs);
    // Only fetch those we don't already have loaded
    const missing = customSlugs?.filter(slug => !layout?.customSettings[slug]);
//console.log('missing',layout?.customSettings);
    if (missing?.length === 0) return;
      try {
        const newCustom = { ...layout?.customSettings };

       // await Promise.all(
          missing?.map(async (slug) => {
            try {
              newCustom[slug]=customSettings[slug];
              //console.log("Here mow",customSettings['testimonials-2'])
            // console.log("Cached",JSON.parse(localStorage.getItem("sc")));
            /**  const res = await axios.get(
                `${config.API_URL}/api/customsettings/${slug}`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                  withCredentials: true,
                }
              );


              if (res.data?.customSettings) {
                newCustom[slug] = res.data.customSettings;
              } else if (res.data?.settings) {
                // fallback - some endpoints might return "settings" key
                newCustom[slug] = res.data.settings;
              }**/
            } catch (err) {
              //console.warn(`Failed to load custom config for ${slug}:`, err);
            }
          })
       // );

        if (Object.keys(newCustom)?.length > Object.keys(layout?.customSettings)?.length) {
          setCustomConfigs(newCustom);

          // Update cache with new custom configs
          const currentCache = localStorage.getItem(CACHE_KEY);
          if (currentCache) {
            try {
              const parsed = JSON.parse(currentCache);
              localStorage.setItem(CACHE_KEY, JSON.stringify({
                ...parsed,
                data: {
                  ...parsed.data,
                  custom: newCustom
                },
                ts: Date.now()
              }));
            } catch {}
          }
        }
      } catch (err) {
        //console.error("Batch load of custom configs failed", err);
      }
    };




useEffect(() => {

  if (!layout?.freshOrder) return;   // safety
//console.log(layout?.customSettings['testimonials-2']);
  setSectionOrder(layout.freshOrder);
  setGlobalConfigs(layout.freshGlobal);
  setCatConfig(layout.categoriesnav_2 ?? {});
  setCustomSettings(layout.customSettings);
  setCustomConfigs(layout.customSettings);
  loadMissingCustom();
}, [layout]);

  // ── Background data loading ────────────────────────────────────────────────
/**useEffect(() => {
  if (hasFetched.current) return;
  hasFetched.current = true;

  const loadData = async () => {
    // ================================================================
    // 1. ALWAYS load whatever is in cache FIRST (stale is OK)
    //    → this is what prevents you from seeing DEFAULT_ configs
    // ================================================================
    const cachedStr = localStorage.getItem(CACHE_KEY);
    let hasStaleCache = false;
    let staleTs = 0;

    if (cachedStr) {
      try {
        const parsed = JSON.parse(cachedStr);
        const { data, ts } = parsed;

        staleTs = ts || 0;
        hasStaleCache = true;

        setSectionOrder(data.order || DEFAULT_LAYOUT_ORDER);
        setGlobalConfigs((prev) => ({ ...prev, ...data.global || {} }));
        setCustomConfigs(data.custom || {});
      } catch (e) {
        //console.warn("Invalid cache format, clearing");
        localStorage.removeItem(CACHE_KEY);
      }
    }

 

    // ================================================================
    // 2. Only fetch fresh data when cache is expired OR missing
    // ================================================================
    const isExpired = !hasStaleCache || Date.now() - staleTs >= CACHE_TTL;

    if (!isExpired) {
      // Cache is still fresh → we are done
      return;
    }

    // Cache is stale or missing → revalidate
    try {
     // await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, { withCredentials: true });

      const [layoutRes] = await Promise.allSettled([
        axios.get(`${config.API_URL}/api/layoutsettings`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }),
      ]);

      // If the API call failed but we have stale data → keep the stale data
      if (layoutRes.status !== "fulfilled") {
        //console.warn("API fetch failed – keeping last cached data");
        return;
      }

      // Build fresh global config (same logic you already had)
      const freshGlobal = { ...DEFAULT_GLOBAL_CONFIGS };

      freshGlobal.flashbar = layoutRes.value.data?.flashBarSettings ?? freshGlobal.flashbar;
      freshGlobal.navbar = layoutRes.value.data?.navBarSettings ?? freshGlobal.navbar;
      freshGlobal.banner = layoutRes.value.data?.bannerSettings ?? freshGlobal.banner;
      freshGlobal.hero = layoutRes.value.data?.heroSettings ?? freshGlobal.hero;
      freshGlobal.categoriesnav_2 = layoutRes.value.data?.catSettings ?? freshGlobal.categoriesnav_2;
      freshGlobal.categories = layoutRes.value.data?.categorySettings ?? freshGlobal.categories;
      freshGlobal.products = layoutRes.value.data?.productSettings ?? freshGlobal.products;
      freshGlobal.footer = layoutRes.value.data?.footerSettings ?? freshGlobal.footer;

      const freshOrder = layoutRes.value.data?.order || DEFAULT_LAYOUT_ORDER;
//setCustomSettings(layoutRes.value.data?.customSettings);


      // Update UI with fresh data
      setSectionOrder(freshOrder);
      setGlobalConfigs(freshGlobal);

      // Keep your existing search/cart cache handling
      const otherCache = getCachedLayout();
      setSearchConfig(otherCache?.search || null);
       setCatConfig(layoutRes.value.data?.catSettings ?? {});
      setCartConfig(otherCache?.cart || null);
  

      // Cache the fresh result (24 h TTL)
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          data: {
            order: freshOrder,
            global: freshGlobal,
            custom: customConfigs, // will be enriched by the second useEffect
          },
          ts: Date.now(),
        })
      );
    } catch (err) {
      //console.warn("Background data load failed – keeping last cached data", err);
      // IMPORTANT: we NEVER clear the cache on error
    }
  };

  loadData();
}, [token, dataVersion]);   **/



    // ── Load missing custom/variant configs when sectionOrder is known ───────
  
   


   



 const getCachedLayout = () => {
    const item = localStorage.getItem(CACHE_KEY_LAYOUT);
    if (!item) return null;
    try {
      const { data, ts } = JSON.parse(item);
      if (Date.now() - ts < CACHE_TTL) return data;
      localStorage.removeItem(CACHE_KEY_LAYOUT);
      return null;
    } catch {
      localStorage.removeItem(CACHE_KEY_LAYOUT);
      return null;
    }
  };

  // ── Add New Section Handler ────────────────────────────────────────────────
  const handleAdd = async () => {
    if (!selectedSection) return;

    setAdding(true);
    setAddError(null);
    setAddSuccess(null);

    try {
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      if (!xsrfToken) throw new Error("No XSRF token");

      const response = await axios.post(
        `${config.API_URL}/api/addNewSection`,
        { section: selectedSection },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken),
            "Authorization": `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === 1) {
        setAddSuccess(`Added ${selectedSection} (${response.data.new_slug || 'new section'})`);
        setTimeout(() => {
          setIsAddModalOpen(false);
          setSelectedSection(null);
          setAddSuccess(null);
          localStorage.removeItem(CACHE_KEY);
          setDataVersion(v => v + 1);
        }, 1800);
      } else {
        setAddError(response.data.message || 'Failed to add section');
      }
    } catch (error) {
      //console.error("Add section error:", error);
      setAddError(error.response?.data?.message || "Network error. Please try again.");
    } finally {
      setAdding(false);
    }
  };

  // ── Duplicate Section ──────────────────────────────────────────────────────
  const duplicateSection = async (originalSlug) => {
    try {
      const baseType = originalSlug.split('-')[0];

      let originalConfig;
      if (originalSlug.includes('-')) {
        originalConfig = customConfigs[originalSlug];
      } else {
        originalConfig = globalConfigs[baseType === 'product-view' ? 'product-view' : baseType];
      }

      if (!originalConfig) {
        alert("Cannot duplicate - no configuration found.");
        return;
      }

      const nextNumber = getNextDuplicateNumber(baseType);
      const newSlug = `${baseType}-${nextNumber}`;

      const newConfig = JSON.parse(JSON.stringify(originalConfig));

      if (newConfig.customStyles) {
        newConfig.customStyles.note = "This is a copy";
      }

      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      if (!xsrfToken) throw new Error("No XSRF token");

      const capitalized = baseType.charAt(0).toUpperCase() + baseType.slice(1);
      const saveEndpoint = `${config.API_URL}/api/saveCustomSettings/${capitalized}/${newSlug}`;

      const saveRes = await axios.post(saveEndpoint, { settings: newConfig }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-XSRF-TOKEN": decodeURIComponent(xsrfToken),
          "Authorization": `Bearer ${token}`,
        },
        withCredentials: true,
      });

      if (saveRes.data.status !== 1) {
        throw new Error("Failed to save new section");
      }

      const newOrder = [...sectionOrder];
      const originalIndex = newOrder.indexOf(originalSlug);
      newOrder.splice(originalIndex + 1, 0, newSlug);

      await axios.post(config.API_URL + "/api/saveLayoutSettings", { order: newOrder }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-XSRF-TOKEN": decodeURIComponent(xsrfToken),
          "Authorization": `Bearer ${token}`,
        },
        withCredentials: true,
      });

      setSectionOrder(newOrder);
      localStorage.removeItem(CACHE_KEY);
      alert(`Duplicated as ${newSlug}!`);
    } catch (error) {
      //console.error("Duplication failed:", error);
      alert("Failed to duplicate section.");
    }
  };

  // ── Delete Section ─────────────────────────────────────────────────────────
  const deleteSection = async (slugToDelete) => {
    if (!window.confirm(`Delete "${slugToDelete}"? This cannot be undone.`)) return;

    try {
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      if (!xsrfToken) throw new Error("No XSRF token");

      await axios.get(
        `${config.API_URL}/api/deleteSection/${slugToDelete}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken),
          },
          withCredentials: true,
        }
      );

      const newOrder = sectionOrder?.filter(s => s !== slugToDelete);
      setSectionOrder(newOrder);
      localStorage.removeItem(CACHE_KEY);
      alert('Section deleted!');
    } catch (error) {
      //console.error("Delete failed:", error);
      alert("Failed to delete section.");
    }
  };

  // ── Move Section ───────────────────────────────────────────────────────────
  const moveSection = (fromIndex, direction) => {
    const toIndex = fromIndex + direction;
    if (toIndex < 0 || toIndex >= sectionOrder?.length) return;

    const newOrder = [...sectionOrder];
    const [moved] = newOrder.splice(fromIndex, 1);
    newOrder.splice(toIndex, 0, moved);
    setSectionOrder(newOrder);
  };

  // ── Save Layout Order ──────────────────────────────────────────────────────
  const saveLayout = async () => {
    try {
      setSaving(true);
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      if (!xsrfToken) throw new Error("No XSRF token");

      const res = await axios.post(
        config.API_URL + "/api/saveLayoutSettings",
        { order: sectionOrder },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken),
            "Authorization": `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (res.data.status === 1) {
        alert("Layout saved!");
        localStorage.removeItem(CACHE_KEY);
      } else {
        alert("Save failed.");
      }
    } catch (error) {
      alert("Failed to save layout.");
    } finally {
      setSaving(false);
    }
  };

  const getNextDuplicateNumber = (baseType) => {
    const existingNumbers = sectionOrder
      .filter(s => s.startsWith(baseType + '-'))
      .map(s => {
        const match = s.match(/-(\d+)$/);
        return match ? parseInt(match[1], 10) : 1;
      });
    return existingNumbers.length === 0 ? 2 : Math.max(...existingNumbers) + 1;
  };


  // ── Render section with skeleton fallback ──────────────────────────────────
   // ── Render section with skeleton fallback for loading customs ────────────
  const renderSection = useCallback((slug) => {
    const baseType = slug.split('-')[0];
    const isCustom = slug.includes('-');

    // Get config: prefer custom → global → empty object
    const config = isCustom
      ? (customConfigs[slug] ?? globalConfigs[baseType] ?? {})
      : (globalConfigs[baseType] ?? {});

    // If it's a custom slug and we still don't have data → show skeleton
   /** if (isCustom && !customConfigs[slug] && !globalConfigs[baseType]) {
      return <SkeletonSection height="180px" className="bg-gray-100" />;
    }**/

    switch (baseType.toLowerCase()) {
      case 'flashbar':
        return <FlashBar config={config} />;
      case 'navbar':
        if(CatConfig.length>0){
           return <NavigationBar config={config} searchConfig={searchConfig} CatConfig={CatConfig} />;
        }else{
           return <NavigationBar config={config} searchConfig={searchConfig} CatConfig={CatConfig} />;
        }
       
      case 'banner':
        return <Banner config={config} />;
      case 'hero':
        return <HeroSection config={config} />;
      case 'categories':
        return <CategorySection config={config} />;
      case 'products':
        return <ProductSection config={config} slug={slug} />;
      case 'testimonials':
        return <Testimonials config={config} />;
         case 'cta':
        return <Cta config={config} />;
         //case 'categoriesnav':
       // return <CategoriesNav config={config} />;
         case 'faqs':
        return <Faqs config={config} />;
          case 'christmas':
        return <Christmas config={config} />;
          case 'marketingmodals':
        return <ModalSection config={config} />;
      case 'cart':
        return <CartSection config={config} isOpen={false} onClose={() => {}} />;
      case 'footer':
        return <FooterSection config={config} />;
      case 'product-view':
        return <ProductView config={config} />;
      default:
        return ;
    }
  }, [globalConfigs, customConfigs, searchConfig]);

    // ── Force refresh from server ─────────────────────────────────────────────
  const handleManualRefresh = useCallback(() => {
    localStorage.removeItem(CACHE_KEY);
    setDataVersion(prev => prev + 1);
    window.location.reload();
  }, []);


  // ── Admin editing modal ────────────────────────────────────────────────────
  if (editingSlug) {
    const baseType = editingSlug.split('-')[0];
    const isCustom = editingSlug.includes('-');

    const AdminComponents = {
      flashbar: FlashBarAdmin,
      navbar: NavigationAdmin,
      hero: HeroAdmin,
      banner: BannerAdmin,
      categories: CategoryAdmin,
      products: ProductAdmin,
      cart: CartAdmin,
      footer: FooterAdmin,
      search: SearchAdmin,
      testimonials: TestimonialsAdmin,
       cta: CtaAdmin,
      categoriesnav: CategoriesNavAdmin,
      faqs: FaqAdmin,
      marketingmodals: ModalAdmin,
      christmas: ChristmasAdmin,
      "product-view": ProductViewAdmin,
    };

    const AdminComponent = AdminComponents[baseType];

    if (!AdminComponent) {
      return (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-white p-10 rounded-xl shadow-2xl">
            <p className="text-xl text-red-600">No editor available for: {baseType}</p>
          </div>
        </div>
      );
    }

    const currentConfig = isCustom 
      ? (customConfigs[editingSlug] || null)
      : (globalConfigs[baseType] || null);

    return (
      <div className="fixed inset-0 bg-black/70 z-50 flex items-start justify-center overflow-auto pt-12 pb-12">
        <div className="bg-white w-full max-w-9xl rounded-xl shadow-2xl overflow-hidden mx-4">
          <div className="p-6 border-b flex justify-between items-center bg-gray-50">
            <h2 className="text-2xl font-bold capitalize">
              Edit {baseType.replace('-', ' ')} ({editingSlug})
            </h2>
            <button 
              onClick={() => setEditingSlug(null)}
              className="text-3xl text-gray-600 hover:text-gray-900"
            >
              ×
            </button>
          </div>
          <div className="p-6">
            <React.Suspense fallback={<div className="text-center py-12">Loading editor...</div>}>
              <AdminComponent 
                config={currentConfig || {}}
                slug={editingSlug}
                onSave={(updated) => {
                  if (isCustom) {
                    setCustomConfigs(prev => ({ ...prev, [editingSlug]: updated }));
                  } else {
                    setGlobalConfigs(prev => ({ ...prev, [baseType]: updated }));
                  }
                  localStorage.removeItem(CACHE_KEY);
                  setEditingSlug(null);
                }}
                onClose={() => setEditingSlug(null)}
              />
            </React.Suspense>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <div
          className="w-14 h-14 rounded-full border-4 border-t-transparent animate-spin mb-5"
          style={{ borderColor: config.BASE_COLOR, borderTopColor: 'transparent' }}
        />
        <p className="text-xl font-bold tracking-wide" style={{ color: config.BASE_COLOR }}>
          {config.STORE_NAME}
        </p>
        <p className="text-sm text-gray-400 mt-1">Loading store, please wait…</p>
      </div>
    );
  }

  if (error || !sectionOrder?.length) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
        <div className="text-center max-w-sm">
          <div className="text-5xl mb-4">🍷</div>
          <p className="text-xl font-bold mb-1" style={{ color: config.BASE_COLOR }}>
            {config.STORE_NAME}
          </p>
          <p className="text-gray-500 text-sm mb-6">
            {error
              ? 'Could not connect to the server. Please check your connection or try again.'
              : 'No content available. The store may still be setting up.'}
          </p>
          <button
            onClick={() => refetch()}
            className="px-6 py-2 rounded-full text-white text-sm font-semibold transition-opacity hover:opacity-80"
            style={{ backgroundColor: config.BASE_COLOR }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
<style>{`
       @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=Quicksand:wght@400;500;600;700&display=swap');
     html,body{
       font-family: ${config.FONT_FAMILY}, sans-serif !important;
     }
      `}
      </style>
      {/* Admin controls */}
      <div className="fixed top-5 left-5 z-50 flex flex-wrap gap-3">
       {/* 
       {system_role=="Admin" && (

        <button
          onClick={() => setIsAdminMode(!isAdminMode)}
          className={`px-6 py-3 rounded-full font-bold shadow-xl transition-colors ${
            isAdminMode 
              ? 'bg-red-600 hover:bg-red-700 text-white' 
              : 'bg-emerald-600 hover:bg-emerald-700 text-white'
          }`}
        >
          {isAdminMode ? 'Exit Edit Mode' : 'Enter Edit Mode'}
        </button>
        )}*/}

        {isAdminMode && (
          <>
            <button
              onClick={() => setIsAddModalOpen(true)}
              className="px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-full font-bold shadow-xl transition-all flex items-center gap-2"
            >
              <Plus size={20} />
              Add Section
            </button>

            <button
              onClick={handleManualRefresh}
              className="px-5 py-3 bg-amber-600 hover:bg-amber-700 text-white rounded-full font-bold shadow-xl transition-all flex items-center gap-2"
              title="Force reload all data from server"
            >
              <RefreshCw size={18} />
              Refresh Data
            </button>
          </>
        )}
      </div>

      {/* Main content - renders from defaults instantly */}
      {sectionOrder?.map((slug, index) => (
        <div key={slug} className="relative">
          {renderSection(slug)}

          {true && (
          <> 
           {isAdminMode && (
            <div className="absolute top-16  right-2 bg-white/90 backdrop-blur p-3 rounded-lg shadow-xl flex gap-2 z-50 flex-wrap">
              <button onClick={() => setEditingSlug(slug)} className="p-2 bg-green-50 hover:bg-green-100 text-green-700 rounded text-sm">Edit</button>
              <button onClick={() => duplicateSection(slug)} className="p-2 bg-purple-50 hover:bg-purple-100 text-purple-700 rounded text-sm">Duplicate</button>
              <button onClick={() => deleteSection(slug)} className="p-2 bg-red-50 hover:bg-red-100 text-red-700 rounded text-sm">Delete</button>
              <button onClick={() => moveSection(index, -1)} disabled={index === 0} className="p-2 hover:bg-gray-100 rounded disabled:opacity-50 text-sm">↑</button>
              <button onClick={() => moveSection(index, 1)} disabled={index === sectionOrder?.length - 1} className="p-2 hover:bg-gray-100 rounded disabled:opacity-50 text-sm">↓</button>
            </div>
          )}
          </>
          )}

            {(slug.trim().toLowerCase()==='navbar' || slug.trim().toLowerCase()==='flashbar') && (
          <> 
           {isAdminMode && (
            <div className="absolute top-2 right-2 bg-white/90 backdrop-blur p-3 rounded-lg shadow-xl flex gap-2 z-50 flex-wrap">
              <button onClick={() => setEditingSlug(slug)} className="p-2 bg-green-50 hover:bg-green-100 text-green-700 rounded text-sm">Edit</button>
              <button onClick={() => duplicateSection(slug)} className="p-2 bg-purple-50 hover:bg-purple-100 text-purple-700 rounded text-sm">Duplicate</button>
              <button onClick={() => deleteSection(slug)} className="p-2 bg-red-50 hover:bg-red-100 text-red-700 rounded text-sm">Delete</button>
              <button onClick={() => moveSection(index, -1)} disabled={index === 0} className="p-2 hover:bg-gray-100 rounded disabled:opacity-50 text-sm">↑</button>
              <button onClick={() => moveSection(index, 1)} disabled={index === sectionOrder?.length - 1} className="p-2 hover:bg-gray-100 rounded disabled:opacity-50 text-sm">↓</button>
            </div>
          )}
          </>
          )}
        </div>
      ))}

      {/* Save layout bar */}
      {isAdminMode && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 bg-white/95 backdrop-blur-lg px-10 py-5 rounded-full shadow-2xl flex items-center gap-8 z-50 border border-gray-200">
          <button
            onClick={() => {
              saveLayout();
              setSaving(true);
              setTimeout(() => setSaving(false), 1200);
            }}
            disabled={saving}
            className="bg-green-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-700 disabled:opacity-60 transition"
          >
            {saving ? 'Saving...' : 'Save Layout Order'}
          </button>
          <span className="text-gray-600 text-sm">↑↓ reorder • Edit • Duplicate • Delete</span>
        </div>
      )}


       {/* Add New Section Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-8 py-5 flex justify-between items-center z-10">
              <h2 className="text-2xl font-bold text-gray-900">Add New Section</h2>
              <button onClick={() => setIsAddModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                <X size={28} />
              </button>
            </div>

            <div className="p-8">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 mb-10">
                {availableSections?.map((type) => (
                  <button
                    key={type.id}
                    onClick={() => setSelectedSection(type.id)}
                    className={`flex flex-col items-center p-6 border-2 rounded-xl transition-all duration-200 ${
                      selectedSection === type.id
                        ? 'border-indigo-500 bg-indigo-50 ring-2 ring-indigo-300'
                        : 'border-gray-200 hover:border-indigo-300 hover:bg-gray-50'
                    }`}
                  >
                    <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${type.color}`}>
                      <type.icon size={32} />
                    </div>
                    <span className="font-medium text-gray-800 text-center">{type.name}</span>
                  </button>
                ))}
              </div>

              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setIsAddModalOpen(false)}
                  className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAdd}
                  disabled={!selectedSection || adding}
                  className={`px-8 py-3 rounded-lg font-medium flex items-center gap-2 ${
                    selectedSection && !adding
                      ? 'bg-indigo-600 text-white hover:bg-indigo-700'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
                >
                  {adding ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-white"></div>
                      Adding...
                    </>
                  ) : (
                    'Add Section'
                  )}
                </button>
              </div>

              {addError && <p className="mt-6 text-red-600 text-center">{addError}</p>}
              {addSuccess && <p className="mt-6 text-green-600 text-center">{addSuccess}</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BalancesLayout;